package ds.pms.tokafull.adminweb

import kotlinx.browser.localStorage

internal object AdminSession {
    private const val TOKEN_KEY = "tokafull_admin_token"
    private const val USER_KEY = "tokafull_admin_username"

    fun getToken(): String? = localStorage.getItem(TOKEN_KEY)?.takeIf { it.isNotBlank() }

    fun setSession(token: String, username: String) {
        localStorage.setItem(TOKEN_KEY, token)
        localStorage.setItem(USER_KEY, username)
    }

    fun getUsername(): String? = localStorage.getItem(USER_KEY)

    fun clear() {
        localStorage.removeItem(TOKEN_KEY)
        localStorage.removeItem(USER_KEY)
    }

    fun isSignedIn(): Boolean = !getToken().isNullOrBlank()
}
